import React from 'react';
import * as S from './styles';
import { CardBannerProps } from './types';

/**
 * Used to render a full width banner inside the card.
 */
export default function CardBanner<As extends React.ElementType = 'div'>({
  as,
  children,
  ...props
}: CardBannerProps<As>) {
  const Component = as ?? 'div';

  return (
    <S.Root as={Component} {...props}>
      {children}
    </S.Root>
  );
}
